import { ApplicationRef, ChangeDetectorRef, Component, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ExportToCsv } from 'export-to-csv';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { CommonService } from 'src/app/services/common/common.service';
import { EnderecoPersonalizadoService } from 'src/app/services/endereco-personalizado/endereco.personalizado.service';
import { MessageService, ErrorData } from 'src/app/services/message/message.service';
import { ValidatorService } from 'src/app/services/validators/errors-validators.service';
import { HomeComponent } from '../../home/home.component';
import { ImportServiceV2 } from 'src/app/services/imports/import.service-v2';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { showError } from '../../../../utils/showErrorMessage';
import { scheduleAppRefresh } from 'src/app/shared/utils/refresh-view';

type ImportErrorData = {
  description: string;
  error: string;
  lineFile: number;
  lineReal: number;
  type: 'Crítico' | 'Aviso';
};

@Component({
  selector: 'spe-verificar-dados-importados-v2',
  templateUrl: './verificar-dados-importados-v2.component.html',
  styleUrls: ['./verificar-dados-importados-v2.component.scss'],
  standalone: false
})
export class VerificarDadosImportadosV2Component implements OnInit {
  public message: string = '';
  public apiStatus: string | null = null;
  public showLoading: boolean = false;
  public alertTitle: string = 'Processando arquivo';
  public employees: number = 0;
  public benefits: number = 0;
  public errors: number = 0;
  public showStepCounters: boolean = false;
  private subscriptions: Subscription[] = [];
  private idClientGroup = localStorage.getItem('idGrupoCliente');
  public showExtractButton: boolean =
    localStorage.getItem('flagErrosImportacao') == 'true' || localStorage.getItem('SIG') != 'null';
  public sigla = localStorage.getItem('sigla');
  private idImportacao?: string;
  public criticalErrors = new MatTableDataSource<any>([]);

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    if (sort) {
      this.criticalErrors.sort = sort;
      this.criticalErrors.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'description':
            return item.value?.DS_ERRUSU_EVT || '';
          case 'error':
            return item.key || '';
          case 'lineFile':
            return item.value?.DS_LINARQ_IRR || 0;
          case 'lineReal':
            return item.value?.CD_LINREA_IRR || 0;
          case 'type':
            return item.type || '';
          default:
            return item[property];
        }
      };
    }
  }

  public fieldList1: any[] = [];
  public fieldList2: any[] = [];
  public fieldList3: any[] = [];
  public clientAddresses: any[] = [];
  public classifications: string[] = [];
  public addressTitle: string = '';
  public addressTitleNmber: number = 0;
  private type = '';
  public showContinue: boolean = false;
  public showStepFail: boolean = false;
  public alertMessage: string = 'Estamos processando seu arquivo, aguarde...';
  public alertStatus: string | null = null;
  public errorsToShow: any[] = [];
  public filteredOptions: Observable<any[]> | undefined;
  public enableLoop = true;
  public displayedColumnsTable: string[] = ['description', 'error', 'lineFile', 'lineReal', 'type'];
  public dataSourceDetails = new MatTableDataSource<ImportErrorData>();

  validatorErrors = this.validatorService.validatorErrors;

  public mainFormGroup = new FormGroup({
    field1: new FormControl('', [Validators.required]),
    field2: new FormControl('', [Validators.required]),
    field3: new FormControl('', [Validators.required]),
    field4: new FormControl('')
  });

  constructor(
    public readonly routerService: Router,
    private messageService: MessageService,
    private homeComponent: HomeComponent,
    public readonly importService: ImportServiceV2,
    private enderecoPersonalizadoService: EnderecoPersonalizadoService,
    public readonly commonService: CommonService,
    public readonly validatorService: ValidatorService,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private appRef: ApplicationRef,
    private ngZone: NgZone
  ) {}

  private refreshView(): void {
    this.cdr.detectChanges();
    scheduleAppRefresh(this.appRef, this.ngZone);
  }

  ngOnInit(): void {
    this.subscribeInterceptor();
    this.setHomeVariables();
    this.subscribeMainForm();
    this.getEnderecosParaTratamentoDeErrosDoArquivoImportado();
    this.consultarErrosParaTratamento();
    this.getRouteParams();
    this.filteredOptions = this.mainFormGroup.controls.field4.valueChanges.pipe(
      startWith(''),
      map((value: any) => {
        if (typeof value == 'string') {
          return this._filter(value || '');
        } else if (value && typeof value == 'object') {
          return this._filter(value.endereco);
        } else {
          return [];
        }
      })
    );
  }

  private _filter(value: string) {
    const filterValue = this.commonService.removeDiacritics(value);
    return this.fieldList3.filter((option) => {
      return this.commonService.removeDiacritics(option.endereco).includes(filterValue);
    });
  }
  ngOnDestroy(): void {
    this.enableLoop = false;
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  subscribeInterceptor() {
    const messageSubscription = this.messageService.errorData$.subscribe((errorData: ErrorData) => {
      this.showMessage(errorData.errorMessage, errorData.isError);
    });
    this.subscriptions.push(messageSubscription);
  }

  setHomeVariables() {
    this.homeComponent.setNewVariables(
      'Verificar Dados Importados',
      'Foram encontrados inconsistências na importação do seu arquivo. Informações que devem ser corrigidas no arquivo para que a importação seja concluída. Corrija por favor seu arquivo e retorne ao processo de importação.',
      'importacao/importar-arquivo'
    );
    this.homeComponent.idleMenuContent = [];
    this.homeComponent.iconPath = 'assets/images/64_icon_earth_upload.png';
  }

  subscribeMainForm() {
    this.mainFormGroup.controls.field1.valueChanges.subscribe((value) => {
      let item = this.fieldList1.find((element) => {
        return element.idImportacaoEndereco == value;
      });
      this.fieldList2 = [item];

      this.fieldList3 = [];
      this.clientAddresses.forEach((element) => {
        if (item.idClienteNegocio == element.idClienteNegocio) {
          this.fieldList3.push(element);
        }
      });
      this.mainFormGroup.patchValue({
        field2: this.fieldList2[0].idImportacaoEndereco,
        field3: this.fieldList3[0].idEndereco,
        field4: this.fieldList3[0].endereco
      });
    });
  }

  selectOption(value: MatAutocompleteSelectedEvent) {
    this.mainFormGroup.patchValue({
      field3: value.option.value.idEndereco,
      field4: value.option.value.endereco
    });
  }

  public readonly showStatus = (
    element: ImportErrorData
  ): { message: string; status: 'error-chip' | 'success-chip' | 'processed-chip' | 'warning-chip' } => {
    const message = element.type;
    console.log('STATUS', element);
    switch (message) {
      case 'Crítico':
        return { message, status: 'error-chip' };

      case 'Aviso':
        return { message, status: 'warning-chip' };

      default:
        return { message: message, status: 'processed-chip' };
    }
  };

  getEnderecosParaTratamentoDeErrosDoArquivoImportado() {
    const subscription = this.enderecoPersonalizadoService
      .consultarEnderecosParaTratamentoDeErrosDoArquivoImportado(this.idClientGroup!)
      .subscribe({
        next: (data) => {
          Object.values(data['enderecosImportacoes'] as object).forEach((element) => {
            this.fieldList1.push(element);
          });
          Object.values(data['enderecosClientes'] as object).forEach((element) => {
            this.clientAddresses.push(element);
          });

          if (this.fieldList1.length > 0) {
            this.mainFormGroup.patchValue({
              field1: this.fieldList1[0].idImportacaoEndereco
            });
          }
          this.refreshView();
        },
        error: (e) => {
          let errorMensagem: string = e.error.mensagem;
          this.showLoading = false;

          this.showStepFail = true;

          this.errorsToShow.push(`Contate a Central de Atendimento e informe o erro [5 ${errorMensagem}`);
          this.refreshView();
        }
      });
    this.subscriptions.push(subscription);
  }

  consultarErrosParaTratamento() {
    this.showLoading = true;
    const subscription = this.importService.consultarErrosParaTratamento(this.idClientGroup!).subscribe({
      next: (data) => {
        if (data != null) {
          this.showLoading = false;
        }
        if (data == null) {
          this.showMessage('Finalizando, aguarde...');
          this.commonService.autoScroll();
          this.refreshView();
          const subscription = this.importService
            .concluirImportacao(this.idClientGroup!, this.idImportacao!)
            .subscribe({
              next: () => {
                this.consultarAndamento();
              },
              error: (e) => {
                let errorMensagem: string = e.error.mensagem;
                this.showLoading = false;
                this.showAlertMessage('Erro na geração da importação.');
                this.errorsToShow.push(`Contate a Central de Atendimento e informe o erro [5 ${errorMensagem}`);
                this.refreshView();
              }
            });
          this.subscriptions.push(subscription);
          return;
        }
        if (data['errosArquivo']) {
          if (data['errosArquivo']['errosClassificados']) {
            if (data['errosArquivo']['errosClassificados']['Crítico']) {
              Object.entries(data['errosArquivo']['errosClassificados']['Crítico']).forEach((value) => {
                if (value[0] != 'idImportacao') {
                  Object.entries(value[1] as object).forEach((element) => {
                    if (element[0] != 'TEXTOS') {
                      this.criticalErrors.data = [
                        ...this.criticalErrors.data,
                        { key: value[0], value: element[1], type: 'Crítico' }
                      ];
                    } else {
                      this.addressTitle = element[1]['TITUL_END'];
                    }
                  });
                }
              });

              if (data['errosArquivo']['errosClassificados']['Crítico']['Endereço']) {
                if (data['errosArquivo']['errosClassificados']['Crítico']['Endereço'] != null) {
                  this.addressTitleNmber =
                    Object.entries(data['errosArquivo']['errosClassificados']['Crítico']['Endereço']).length - 1;
                }
              }
            } else {
              this.showContinue = true;
            }
            if (data['errosArquivo']['errosClassificados']['Aviso']) {
              Object.entries(data['errosArquivo']['errosClassificados']['Aviso']).forEach((value) => {
                if (value[0] != 'idImportacao') {
                  Object.entries(value[1] as object).forEach((element) => {
                    if (element[0] != 'TEXTOS') {
                      this.criticalErrors.data = [
                        ...this.criticalErrors.data,
                        { key: value[0], value: element[1], type: 'Aviso' }
                      ];
                    } else {
                      this.addressTitle = element[1]['TITUL_END'];
                    }
                  });
                }
              });
            }
          }
        }
        this.refreshView();
      },
      error: () => {
        this.refreshView();
      }
    });
    this.subscriptions.push(subscription);
  }

  getRouteParams() {
    this.idImportacao = this.routerService.routerState.snapshot.url.split('/')[5].split('?')[0];

    const queryParamsSubscription = this.activatedRoute.queryParams.subscribe((params) => {
      this.type = params.tipo;
    });
    this.subscriptions.push(queryParamsSubscription);
  }

  public consultarAndamento = () => {
    const subscription = this.importService
      .consultarAndamentoConclusao(this.idClientGroup!, this.idImportacao!)
      .subscribe({
        next: (d) => {
          if (d.importacaoControle.flagStatus == 'C') {
            this.routerService.navigate([`home/importacao/importar-arquivo/${this.type}`], {
              state: { success: true }
            });
          } else if (d.importacaoControle.flagStatus == 'E' || d.importacaoControle.flagStatus == 'F') {
            this.showLoading = false;
            this.homeComponent.setNewVariables('Verificar Dados Importados', '', 'importacao/importar-arquivo');
            this.showMessage(`${d.importacaoControle.codigoDoErro} - ${d.importacaoControle.descricaoDoErro}`);
            this.commonService.autoScroll();
          } else if (d.importacaoControle.flagStatus == 'P') {
            setTimeout(() => {
              if (this.enableLoop) {
                this.consultarAndamento();
              }
            }, 20000);
          } else {
            this.showLoading = false;
            this.homeComponent.setNewVariables('Verificar Dados Importados', '', 'importacao/importar-arquivo');
            this.showMessage(`Algo deu errado ao concluir a importação`);
            this.commonService.autoScroll();
          }
          this.refreshView();
        },
        error: () => {
          this.showLoading = false;
          this.homeComponent.setNewVariables('Verificar Dados Importados', '', 'importacao/importar-arquivo');
          this.commonService.autoScroll();
          this.refreshView();
        }
      });
    this.subscriptions.push(subscription);
  };

  public continueButton = () => {
    this.errorsToShow = [];
    this.alertStatus = null;
    this.showLoading = true;
    this.homeComponent.setNewVariables('', '');
    // this.showMessage('Finalizando, aguarde...');
    this.commonService.autoScroll();

    const subscription = this.importService.concluirImportacao(this.idClientGroup!, this.idImportacao!).subscribe({
      next: (d) => {
        this.consultarAndamento();
      },
      error: (e) => {
        let errorMensagem: string = e.error.mensagem;
        this.showLoading = false;
        this.showAlertMessage('Erro na geração da importação.');

        this.errorsToShow.push(`Contate a Central de Atendimento e informe o erro [5 ${errorMensagem}`);
        this.refreshView();
      }
    });
    this.subscriptions.push(subscription);
  };

  public readonly csvButton = () => {
    this.errorsToShow = [];
    this.alertStatus = null;

    let objectArray: Array<any> = [];

    this.criticalErrors.data.forEach((element) => {
      const array: Array<any> = [];
      array.push(element['key']);
      array.push(Object.values(element['value'])[1]);
      array.push(Object.values(element['value'])[8]);
      array.push('Crítico');
      array.push(Object.values(element['value'])[10]);
      array.push(Object.values(element['value'])[2]);

      objectArray.push(array);
    });

    const options = {
      filename: `Erros-Importaçao${this.idImportacao}`,
      fieldSeparator: ';',
      decimalSeparator: ',',
      showLabels: true,
      useTextFile: false,
      useBom: true,
      headers: ['ERRO', `DESCRIÇÃO`, 'MOTIVO', 'TIPO', 'LINHA DO ARQUIVO', 'LINHA DO REAL']
    };
    const csvExporter = new ExportToCsv(options);
    csvExporter.generateCsv(objectArray);
  };

  public readonly apbButton = () => {
    this.errorsToShow = [];
    this.alertStatus = null;
    const subscription = this.importService
      .consultarArquivoImportadoFormatoApb(this.idClientGroup!, this.idImportacao!)
      .subscribe({
        next: () => {},
        error: () => {
          this.showLoading = false;
          this.refreshView();
        }
      });
    this.subscriptions.push(subscription);
  };

  public readonly includeAddress = () => {
    this.showLoading = true;
    const subscription = this.importService
      .incluirEnderecoNaImportacao(this.idClientGroup!, this.idImportacao!, this.mainFormGroup.value.field1!)
      .subscribe({
        next: () => {
          window.location.reload();
        },
        error: (e) => {
          this.apiStatus = null;
          this.showLoading = false;
          this.errorsToShow = [];
          let errorMensagem: string = e.error.mensagem;
          this.showAlertMessage('Erro na associação ou inclusão dos endereços da importação.');
          this.errorsToShow.push(errorMensagem);
          this.refreshView();
        }
      });
    this.subscriptions.push(subscription);
  };

  public readonly associateAddress = () => {
    this.showLoading = true;
    const subscription = this.importService
      .associarEnderecoAImportacao(
        this.idClientGroup!,
        this.idImportacao!,
        this.mainFormGroup.value.field1!,
        this.mainFormGroup.value.field3!
      )
      .subscribe({
        next: () => {
          window.location.reload();
        },
        error: (e) => {
          this.apiStatus = null;
          this.showLoading = false;
          this.errorsToShow = [];
          let errorMensagem: string = e.error.mensagem;
          this.showAlertMessage('Erro na busca dos endereços da importação.');
          this.errorsToShow.push(errorMensagem);
          this.refreshView();
        }
      });
    this.subscriptions.push(subscription);
  };

  public readonly extractErrors = () => {
    this.errorsToShow = [];
    this.alertStatus = null;

    let body = { idImportacao: this.idImportacao, flagExtrairErroParaTratamento: 'S' };
    const subscription = this.importService.finalizarProcessamento(this.idClientGroup!, body).subscribe({
      next: () => {
        window.location.reload();
      },
      error: () => {
        this.showLoading = false;
        this.refreshView();
      }
    });

    this.subscriptions.push(subscription);
  };

  private readonly showMessage = (text: string = '', errorMessage: boolean = false) => {
    this.apiStatus = errorMessage ? 'error' : 'success';
    this.message = text;
  };

  private readonly showAlertMessage = (text: string = '', errorMessage: boolean = false) => {
    this.alertStatus = errorMessage ? 'error' : 'success';
    this.alertMessage = text;
  };

  public clearInput = () => {
    this.mainFormGroup.controls.field4.setValue('');
  };
}
